import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import DealerAddressDropdownBySap from '../../../../../components/common/DealerAddressDropDownBySap';
import BrandDropdown from '../../../../../components/common/BrandDropdown';
import { useLanguage } from '../../../../../contexts/LanguageContext';

const AddressBrandBlock = ({ block, sapDealerId, submitted, readOnly, setBlockField, onAddressChange, onContractStartDateChange }) => {
    const { th } = useLanguage();
    const inv = (cond) => (submitted && cond ? 'p-invalid' : '');
    const isSaved = block.dealerAddressBrandId != null;
    const identityLocked = readOnly || isSaved;

    const isPending = (key) => Array.isArray(block.changedFields) && block.changedFields.includes(key);
    const pendingBadge = (key) => (isPending(key) ? <Tag className="ml-2" severity="warning" icon="pi pi-exclamation-circle" value={th('dealerApproval.updatedBadge')} /> : null);

    return (
        <div className="p-fluid">
            <Divider align="left">
                <span className="font-bold">{th('dealerRegistration.form.addressInfo')}</span>
            </Divider>
            <div className="grid">
                <div className="field col-12 md:col-6">
                    <label className="font-bold block mb-2">{th('dealerRegistration.field.sapAddrId')}</label>
                    {isSaved ? (
                        <InputText value={block.address || block.addressName || block.sapAddrId} disabled />
                    ) : (
                        <DealerAddressDropdownBySap
                            value={block.sapAddrId ? { id: Number(block.sapAddrId), displayValue: block.address, country: block.country } : null}
                            onChange={onAddressChange}
                            dealerId={Number(sapDealerId) || undefined}
                            disabled={!sapDealerId || readOnly}
                            autoSelectFirst={false}
                            className={inv(!block.sapAddrId)}
                            placeholder={th('dealerRegistration.field.sapAddrId')}
                        />
                    )}
                    {submitted && !block.sapAddrId && <small className="p-error">{th('dealerRegistration.addressRequired')}</small>}
                </div>
                <div className="field col-12 md:col-6">
                    <label className="font-bold block mb-2">
                        {th('dealerRegistration.field.addressName')} {pendingBadge('addressName')}
                    </label>
                    <InputText value={block.addressName} disabled />
                </div>
                <div className="field col-12 md:col-6">
                    <label className="font-bold block mb-2">
                        {th('dealerRegistration.field.country')} {pendingBadge('country')}
                    </label>
                    <InputText value={block.country || ''} disabled />
                </div>
                <div className="col-12">
                    <div className="field-checkbox">
                        <Checkbox inputId={`addressIsActive_${block.key}`} checked={!!block.addressIsActive} disabled={readOnly} onChange={(e) => setBlockField(block.key, 'addressIsActive')(e.checked)} />
                        <label htmlFor={`addressIsActive_${block.key}`} className="ml-2">
                            {th('dealerRegistration.field.isActive')} {pendingBadge('addressIsActive')}
                        </label>
                    </div>
                </div>
            </div>

            <Divider align="left">
                <span className="font-bold">{th('dealerRegistration.form.brandInfo')}</span>
            </Divider>
            <div className="grid">
                <div className="field col-12 md:col-6">
                    <label className="font-bold block mb-2">{th('dealerRegistration.field.brandId')}</label>
                    <BrandDropdown
                        key={block.selectedBrand?.id ?? `none_${block.key}`}
                        value={block.selectedBrand}
                        onChange={setBlockField(block.key, 'selectedBrand')}
                        disabled={identityLocked}
                        className={inv(!block.selectedBrand?.id)}
                        placeholder={th('dealerRegistration.field.brandId')}
                    />
                    {submitted && !block.selectedBrand?.id && <small className="p-error">{th('dealerRegistration.brandRequired')}</small>}
                </div>
                <div className="field col-12 md:col-6">
                    <label className="font-bold block mb-2">
                        {th('dealerRegistration.field.contractStartDate')} {pendingBadge('contractStartDate')}
                    </label>
                    <Calendar value={block.contractStartDate} onChange={(e) => onContractStartDateChange(e.value)} dateFormat="dd/mm/yy" showIcon disabled={readOnly} className={inv(!block.contractStartDate)} />
                    {submitted && !block.contractStartDate && <small className="p-error">{th('common.requiredField')}</small>}
                </div>
                <div className="field col-12 md:col-6">
                    <label className="font-bold block mb-2">
                        {th('dealerRegistration.field.contractEndDate')} {pendingBadge('contractEndDate')}
                    </label>
                    <Calendar value={block.contractEndDate} onChange={(e) => setBlockField(block.key, 'contractEndDate')(e.value)} dateFormat="dd/mm/yy" showIcon disabled={readOnly} minDate={block.contractStartDate} />
                </div>
                <div className="col-12">
                    <div className="field-checkbox">
                        <Checkbox inputId={`brandIsActive_${block.key}`} checked={!!block.brandIsActive} disabled={readOnly} onChange={(e) => setBlockField(block.key, 'brandIsActive')(e.checked)} />
                        <label htmlFor={`brandIsActive_${block.key}`} className="ml-2">
                            {th('dealerRegistration.field.isActive')} {pendingBadge('brandIsActive')}
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddressBrandBlock;
